import { render, staticRenderFns } from "./vault.vue?vue&type=template&id=fcb6176e&"
import script from "./vault.vue?vue&type=script&lang=js&"
export * from "./vault.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports